import type { InjectionKey } from 'vue';
import { inject } from 'vue';

import type { LoginFlowPlugin } from '../types';

export const PLUGIN_KEY = Symbol('LOGIN_FLOW_PLUGIN') as InjectionKey<LoginFlowPlugin>;

export function useLoginFlowPlugin() {
  const plugin = inject<LoginFlowPlugin>(PLUGIN_KEY);

  if (!plugin) {
    throw new Error('Inject Request was called before initialization. Did you forget to install LoginFlowPlugin ?');
  }

  return plugin;
}
